import { iconsSet } from "../../../../assets/icons/icons";

export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_3pinvesting.png",
      alt: "Estratégias 3P Investing",
    },
    title: "Opere com as estratégias da 3P Investing",
    text: [
      "Disponibilizamos 3 tipos de estratégias que se adequam ao seu perfil de investidor, visando lucratividade e segurança na relação risco/retorno, para exponencializar seus resultados! ",
    ],
    // testimonial: {
    //   author: {
    //     picture: "https://i.pravatar.cc/150?img=70",
    //   },
    // },
  },
  stats: {
    title: "Alguns números da 3P Investing",
    subtitle: "Mais de 6 anos de experiência, operando e gerando retorno de forma automatizada! ",
    data: [
      {
        value: "+3",
        description: "Anos de lucros em conta real",
      },
      {
        value: "+80%",
        description: "De assertividade nas 3 estratégias",
      },
      {
        value: "+500",
        description: "Clientes ativos",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da 3P Investing",
    subtitle: "Veja quais as principais vantagens dos robôs da 3P Investing",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description: "Teste nossas estratégias e confira seu potencial!",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description: "Você só precisa escolher a estratégia, assinar e o resto é conosco!",
      },
      {
        icon: iconsSet.lock_line,
        title: "Segurança e eficiência",
        description: "Nossas estratégias irão utilizar penas o capital que você determinar em sua corretora.",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe tempo",
        description:
          "Você não precisa ficar na frente do gráfico para realizar suas operações. Escolha uma de nossas estratégias e deixe que fazemos isso por você!",
      },
      {
        icon: iconsSet.growth,
        title: "Aumente a assertividade",
        description:
          "Nossas estratégias contam com inteligência artificial (IA) na tomada de decisão aumentando a assertividade, e portanto, os retornos.",
      },
      {
        icon: iconsSet.graduation_cap,
        title: "Experiência de mercado",
        description:
          "A 3P Investing está há anos criando estratégias para o mercado financeiro, experiência que gera resultado!",
      },
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo as estratégias da 3P Investing. ",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: " A 3P Investing",
    col1: [
      "Fundada há mais de 6 anos, a 3P tem como objetivo simplificar o acesso a estratégias automatizadas de alta performance para o mercado financeiro, evoluindo e melhorando constantemente a vida financeira de quem é nosso cliente",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Placeholder IA",
  },
  strategies: {
    title: "Estratégias 3P Investing",
    heading: "As melhores estratégias à sua disposição. ",
    subtitle: "Estratégias testadas e comprovadas desde 2022, entregando retornos constantes!",
  },
  testimonials: [
    {
      text: "Uso a estratégia 3P - MODERADO há mais de 6 meses e digo com propriedade que é muito rentável e segura, logo vou diversificar e assinar  a 3P - CONSERVADOR e depois a 3P - AGRESSIVO ",
      author: "Andrei Nouzi",
      job: "Engenheiro Estrutural ",
      image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "Tenho as 3 estratégias e estou muito satisfeito com os resultados, vale cada centavo! ",
      author: "Flávia Damaris dos Santos",
      job: "Empresária",
      image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
  ],
};
